<template>
  <div :class="['container']" v-if="category === 404">
    <h2 key="404h2" class="py-xl">
      Sorry... don't know nothing about this page.
    </h2>
    <h5 key="404h5">Seriously, no clue what your talking about!</h5>
  </div>
  <div
    v-else
    observe-resize="0"
    ref="catalog"
    key="catalog"
    :class="[
      'catalog',
      mobileFiltersOpen ? 'filters-open' : '',
      `el-size--${elementSizes[0]}`
    ]"
  >

    <preloader
      key="page-preloader"
      v-if="!pageReady || !curcategory"
      class=""
    />
    <template v-else>

      <slider
        ref="hero"
        v-if="hero"
        :size="elementSizes[0]"
        v-bind="hero"
        subnote
      >
      </slider>
      <div
        v-if="elementSizes[0] !== 'small' && allReady"
        ref="categories"
        class="catalog-categories px-2xl"
      >
        <router-link
          v-for="cat in catalogCategories"
          :to="cat.path"
          :key="cat.cid"
          :title="cat.title"
        >
          <svg-icon class="inline-icon" :id="cat.url_part"></svg-icon>
          <span class="text--m ml-xs text-gray-8" v-text="cat.title"></span>
        </router-link>
      </div>
      <div
        v-if="elementSizes[0] === 'small'"
        class="flex align-center justify-between px-2xl mobile-top-bar"
      >
        <i
          @click="mobileFiltersOpen = !mobileFiltersOpen"
          :class="[
            'toggle',
            'fas',
            !mobileFiltersOpen ? 'fa-sliders-h' : 'fa-chevron-left'
          ]"
        ></i>
        <div
          v-if="!mobileFiltersOpen"
          ref="categories"
          class="catalog-categories__mobile"
        >
          <a
            class="catalog-categories__cur pr-xs text-blue-7 pb-xs"
            @click.prevent="toggleMobileCats"
            href="#p"
          >
            <span v-text="curcategory.title"></span>
            <i class="fas fa-chevron-down ml-xs"></i
          ></a>
          <transition name="overlay-down" appear>
            <div v-if="openMobileCats" class="catalog-categories__list">
              <router-link
                class="text--s p-l"
                v-for="cat in filterRemaining(catalogCategories)"
                :to="cat.path"
                :key="cat.cid"
                @click.native="toggleMobileCats"
              >
                <svg-icon class="inline-icon" :id="cat.url_part"></svg-icon>
                <span class="ml-s text-gray-8" v-text="cat.title"></span>
              </router-link>
            </div>
          </transition>
        </div>
      </div>

      <p
        v-if="elementSizes[0] !== 'small' && allReady"
        class="subnote unflex pb-xl"
      >
        <span v-text="localize('place_order')"></span>,
        <router-link
          to="/company/contact-us"
          v-text="localize('contact_distributor')"
        ></router-link
        ><br />
        <span v-text="localize('please_note_products') + '.'"></span>
      </p>
      <div class="catalog--inner grid-flex-wrap px-2xl"
        :class="`el-size--${elementSizes[1]}`"
        observe-resize="1"
      >
        <transition name="fade-delayed">
          <p
            v-if="
              elementSizes[0] === 'small' &&
                localizedUIReady &&
                !mobileFiltersOpen
            "
            class="subnote unflex pb-xl"
            ref="mobilenote"
          >
            <span v-text="localize('place_order')"></span>,
            <router-link
              to="/company/contact-us"
              v-text="localize('contact_distributor')"
            ></router-link
            ><br />
            <span v-text="localize('please_note_products') + '.'"></span>
          </p>
        </transition>

        <filter-panel
          :class="[gridReady ? '' : 'waiting']"
          v-if="localizedUIReady"
          @mobile-filters-open="mobileFiltersChanged"
          @filters-changed="filtersChangedHandler"
          @search-by-string="searchByString"
          :trigger-query="triggerQueryChange"
          :ui-filters="filtersHash"
          :category="curcategory"
          :mobile-open="mobileFiltersOpen"
        ></filter-panel>

        <div
          ref="grid"
          class="catalog--grid flex-1 pb-xl"
          :class="[
            !gridReady ? 'loading' : '',
            `el-size--${elementSizes[2]}`,
            gridReady && !filteredItems.length ? 'grid-no-items' : ''
          ]"
          observe-resize="2"
          v-if="!mobileFiltersOpen"
        >
          <!-- <div v-if="elementSizes[2] != 'small'" class="catalog-categories">
            <router-link
              v-for="cat in catalogCategories"
              :to="cat.path"
              v-text="cat.title"
              :key="cat.cid"
            ></router-link>
          </div> -->
          <transition name="fade" appear>
            <h4 class="no-items" v-if="gridReady && !filteredItems.length">
              <i class="fal fa-heart-broken" aria-hidden="true"></i>
              <span v-text="localize('no_match')"
                >No matching products found. Check the filter settings.</span
              >
            </h4>
          </transition>
          <preloader v-if="!gridReady" key="loading"></preloader>
          <keep-alive>
            <grid-items
              grid-type="catalog"
              :paginateditems="finalItems"
              :perload="itemsPerLoad"
            ></grid-items>
          </keep-alive>

        <!--
          <div
            v-if="finalItems.length < filteredItems.length"
            class="infinite rel center text-center py-2xl"
            :class="[!infiniteLoading ? 'hidden' : '']"
            ref="infinite"
          >
            <preloader class="inline-mid" key="infiniting"></preloader>
            <span
              class="text-gray-9 block"
              v-text="localize('loading_more')"
            ></span>
          </div>
        -->


          <!-- <paginate
            ref="paginator"
            name="filteredItems"
            :list="filteredItems"
            :per="itemsPerPage"
            tag="div"
            class="paginate-langs"
            v-else
          >
            <keep-alive>
              <grid-items
                grid-type="catalog"
                :paginateditems="paginated('filteredItems')"
              ></grid-items>
            </keep-alive>
          </paginate>

          <transition name="slide-up" appear>
            <div
              class="pager align-left pt-l"
              v-if="
                gridReady &&
                  (filteredItems.length && filteredItems.length > itemsPerPage)
              "
            >
              <paginate-links
                id="pager"
                ref="pager"
                for="filteredItems"
                :limit="4"
                :show-step-links="true"
                @change="scrollTopGrid"
                :async="true"
                class="no-style"
                :step-links="{ next: localize('Next'), prev: localize('Prev') }"
              ></paginate-links>
            </div>
          </transition> -->
          <!-- <abtn color="blue" v-text="localize('load more')"></abtn> -->
          
        <!-- Load more button -->
          <div v-if="hasMore" class="center text-center py-2xl">
            <abtn @click.native="loadMore" color="blue" icon="fal fa-chevron-down" :class="['btn-more']">
              <span v-text="localize('search_load_more')"></span>
            </abtn>
          </div>

        </div>
      </div>
    </template>
    <keep-alive>
      <router-view
        v-if="currentItem"
        :currentItem="currentItem"
        :attr="productAttributesHash"
        :filters-hash="filtersHash"
      ></router-view>
    </keep-alive>
  </div>
</template>
<script>
// import InfiniteLoading from "vue-infinite-loading";
import { mapState, mapActions, mapGetters } from "vuex";
import { storage } from "@/utils";
import SvgIcon from "@/components/SvgIcon.vue";
import CollectionPicker from "@/components/CollectionPicker.vue";
import FilterPanel from "@/components/FilterPanel.vue";
import GridItems from "@/components/grid/GridItems.vue";
// import LayoutGroup from "@/layout/LayoutGroup.vue";
export default {
  data() {
    return {
      itc:-1,
      _int: -1,
      infiniteLoading: false,
      itemsPerPage: 12,
      itemsPerLoad: 12,
      mobileFilterOpen: false,
      loadingItems: false,
      hero: null,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      category: null,
      productAttributesHash: [],
      items: [],
      paginate: ["filteredItems"],
      trigger: -1,
      filteredItems: [],
      filterTimer: 2000,
      hickup: 0,
      triggerQueryChange: -1,
      currentCategoryValue: null,
      categoryChanged: false,
      savedFilterChanged: false,
      activeFilters: [],
      currentItem: null,
      // pageReady: false,
      filtersReady: false,
      gridReady: false,
      cid: null,
      openMobileCats: false,
      mobileFiltersOpen: false,
      searchString: null,
      localeChanged: false,
      scrollTrig: null
    };
  },
  components: {
    CollectionPicker,
    SvgIcon,
    FilterPanel,
    // InfiniteLoading,
    GridItems
  },
  async beforeRouteUpdate(to, from, next) {
    this.triggerQueryChange = new Date().getTime();
    next();
  },
  watch: {
    locale: {
      deep: true,
      handler() {
        this.localeChanged = true;
        this.initCatalog();
      }
    },
    infiniteLoaderTop() {
      console.log("infiite top changed");
      this.checkInfiniteItems();
    },
    $route() {
      // console.log("ROUTE CHANGED...");
      if (this.$route.params.catId && this.items) {
        this.$set(
          this,
          "currentItem",
          _.find(this.items, { cat: this.$route.params.catId })
        );
      }
    },
    "$route.query"() {
      // console.log("QUERY CHANGED >> ", this.$route.query);
      if (this.$refs.paginator) {
        this.$refs.paginator.goToPage(1);
      }
    },
    "curcategory.cid"() {
      // console.log("curcategory has changed > ", this.curcategory);
      this.$set(this, "gridReady", false);
      this.updateFiltersHash([]);
      // this.activeFilters = [];
      this.setCid();
      this.scrollTopGrid();
    },
    cid() {
      this.initCatalog();
    }
  },
  async mounted() {
    window.addEventListener("resize", this.resizeHandler, false);
    this.$nextTick(function() {
      // console.log("1catalog MOUNTED >> ", Object.keys(this.$refs).length);
      this.resizeHandler();
      this.initInfiniteScroll();
    });
    if (this.curcategory && !this.cid) {
      this.setCid();
    }
  },
  destroyed() {
    this.updateFiltersHash([]);
    window.removeEventListener("resize", this.resizeHandler, false);
    window.removeEventListener("scroll", this.scrollHandler, false);
    window.removeEventListener("touchmove", this.mobileScrollStart, false);
    window.removeEventListener("touchend", this.mobileScrollEnd, false);
  },
  computed: {
    ...mapState(["filtersHash", "pageReady", "locale", "localizedUIReady","collections"]),
    ...mapGetters(["catalogCategories"]),
    cCollectingItem()
    {
      return this.gCollectingItem;
    },
    isMobile() {
      let w = document.documentElement.clientWidth || window.innerWidth,
        h = document.documentElement.clientHeight || window.innerHeight;
      return (w > h && w < 813) || (h > w && h < 813);
    },
    infiniteLoaderTop() {
      this.scrollTrig;
      let ref = this.$refs.infinite;
      if (ref) {
        return ref.getBoundingClientRect().top;
      }
      return null;
    },
    hasMore() {
      return this.itemsPerPage < this.filteredItems.length ? true : false;//dubi
      //return true;
    },
    finalItems() {
      console.log("calculate finalItems..", this.filteredItems.length);
      let _items = this.filteredItems.slice(0, this.itemsPerPage); //_.take(this.filteredItems, this.itemsPerPage);
      console.log("2 calculate finalItems");
      return _items;
    },
    subnote() {
      return `${this.localize(
        "place_order"
      )} <router-link to='/company/contact-us' v-text="${this.localize(
        "contact_distributor"
      )}"></router-link> ${this.localize("please_note_products")}.`;
    },
    allReady() {
      return this.localizedUIReady && this.gridReady && this.filtersReady;
    },
    curcategory() {
      let items = this.catalogCategories,
        catName = this.$route.params.catName.toLowerCase();
      if (items) {
        return items.find(item => item.url_part === catName);
      }
      return [];
    }
    // itemsPerPage() {
    //   let trig = this.resizeTrig;
    //   let _grid = this.$refs.grid,
    //     _width = _grid ? _grid.offsetWidth : 0;
    //   // console.log("itemsPerPag width grid >> ", _grid, _width);
    //   // if (_width < 816) {
    //   //   return 10;
    //   // } else if (_width < 1200) {
    //   //   return 12;
    //   // } else {
    //   //   return 24;
    //   // }
    //   if (_width < 816) {
    //     return 12;
    //   } else {
    //     return 36;
    //   }
    // }
  },
  methods: {
    ...mapActions([
      "setItemToCollect",
      "setPageReady",
      "initRawItems",
      "toggleOverlay",
      "initRouteByCid",
      "updateFiltersHash"
    ]),
    // infiniteHandler($state) {
    //   console.log("infiniteHandler > ", this.itemsPerPage, " :: ", $state);
    //   this.$set(this, "itemsPerPage", this.itemsPerPage + 20);
    // },
    closePicker()
    {
      this.setItemToCollect(-1);
    },
    initInfiniteScroll() {
      // var vm = this;
      window.addEventListener("scroll", this.scrollHandler, false);
      window.addEventListener("touchmove", this.mobileScrollStart, false);
      // window.addEventListener("touchend", this.mobileScrollEnd, false);
    },
    scrollHandler: _.debounce(function() {
      this.scrollTrig = new Date().getTime();
      if (this.isMobile) {
        console.log("after scroll, removeinterval");
        clearInterval(this._int);
      }
    }, 100),
    mobileScrollStart: _.debounce(function() {
      clearInterval(this._int);
      console.log(" scrollstart, now interval");

      this._int = setInterval(
        function() {
          this.scrollHandler();
          this.$nextTick(function() {
            this.checkInfiniteItems();
          });
        }.bind(this),
        200
      );
    }, 100),
    mobileScrollEnd() {
      clearInterval(this._int);
      this.checkInfiniteItems();
    },
    checkInfiniteItems: _.debounce(function() {
      return false;//removed by dubi, this method loads more items on scroll, it was disabled because it makes the filters jump
      if (
        this.infiniteLoaderTop &&
        this.infiniteLoaderTop < document.documentElement.clientHeight / 1.1 &&
        this.infiniteLoaderTop > 0
      ) {
          this.infiniteLoading = true;
          setTimeout(
            function() {
              if (this.itemsPerPage < this.filteredItems.length)
                this.itemsPerPage = this.itemsPerPage + this.itemsPerLoad;
              this.infiniteLoading = false;
            }.bind(this),
            400
          );
      }
    }, 200),
    fetchItemPropsString(item) {
      let pick = _.pick(item, [
        "cat",
        "title",
        "description",
        "material",
        "platform",
        "connection"
      ]);
      // console.log("pick> ", pick);
      return _.values(pick)
        .join("")
        .toLowerCase();
    },
    loadMore() {
      console.log("load more...");

      //Added by dubi:
      if (this.itemsPerPage < this.filteredItems.length)
        this.itemsPerPage = this.itemsPerPage + this.itemsPerLoad;
      this.infiniteLoading = false;

    },
    searchByString(string) {
      console.log("searchbystring > ", string);
      if (!string) {
        this.searchString = null;
        this.checkFilters();
      } else {
        this.searchString = string.toLowerCase();
        this.gridReady = false;
        this.$set(this, "filteredItems", []);
        this.$nextTick(async function() {
          this.$set(this, "filteredItems", await this.freeSearchItems());
          console.log("filteredItems by search >  ", this.filteredItems);
          if (!this.loadingItems) {
            this.gridReady = true;
          }
        });
      }
    },
    async freeSearchItems() {
      if (this.searchString) {
        console.log(
          "this.itemSearchProps && this.searchString > ",
          this.searchString
        );
        return this.items.filter(item => {
          let itemPropsString = this.fetchItemPropsString(item);
          // console.log("itemPropsString", itemPropsString);
          return itemPropsString.indexOf(this.searchString) > -1;
        });
      }
      return this.items;
    },
    resizeHandler: _.debounce(function() {
      // console.log("!!!resizeHandler!!!");

      let vm = this;
      if (!this.observed || !this.observed.length) {
        this.observed = document.querySelectorAll("[observe-resize]");
        this.elementSizes.length = this.observed.length;
      }
      // console.log("resize handler", this.observed);
      this.$nextTick(function() {
        this.observed.forEach(function(el, index) {
          vm.elementResizeHandler(el, index);
        });
        this.triggerResize();
      });
    }, 600),
    initResizeElements() {
      // console.log("INIT RESIE EKEMENTS");
      let observed = document.querySelectorAll("[observe-resize]");
      // console.log("observed > ", observed);
      this.elementSizes.length = observed.length;
    },
    elementResizeHandler(el) {
      if (el) {
        let index = el.getAttribute("observe-resize"),
          width = el.offsetWidth;
        // console.log("el, index", el, " :: ", index, " >> ", width);
        if (width > 1200) {
          this.$set(this.elementSizes, index, "large");
        } else if (width > 815) {
          this.$set(this.elementSizes, index, "medium");
        } else {
          this.$set(this.elementSizes, index, "small");
        }
      }
    },
    setCid() {
      let cid,
        category = this.curcategory;
      if (category.cid === 3546) {
        cid = 2214;
      } else if (category.cid === 3548) {
        cid = 2260;
      } else if (category.cid === 3384) {
        cid = 2260;
      } else if (category.cid === 3550) {
        cid = 2308;
      } else if (category.cid === 3549) {
        cid = 2319;
      } else if (category.cid === 3547) {
        cid = 3352;
      }
      this.$set(this, "cid", cid);
    },
    filterRemaining(categories) {
      return _.filter(categories, c => c.cid !== this.curcategory.cid);
    },
    async initCatalog() {
      // console.log("init catalog...");
      this.setPageReady(false);
      // this.pageReady = false;
      // this.$nextTick(async function() {
      await this.fetchData(this.$route);
      this.setPageReady(true);
      // this.pageReady = true;
      this.localeChanged = false;
      this.toggleOverlay(false);
      // this.removeResizeObserver();
      // });
    },
    mobileFiltersChanged(bool) {
      this.mobileFiltersOpen = bool;
    },
    scrollTopGrid() {
      let el = this.$refs.hero;
      if (el && !this.mobileFiltersOpen) {
        // console.log("SCROP <<<< ", el);
        let top = el.$el.offsetTop + el.$el.offsetHeight - 120;
        // console.log("SCROP <<<< ", top);
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
    async fetchData() {
      // this.scrollToTop();
      this.$nextTick(async function() {
        let items = this.catalogCategories,
          catName = this.$route.params.catName.toLowerCase();
        if (!items) {
          await this.initRawItems();
          items = this.catalogCategories;
        }
        let item = items.find(item => item.url_part === catName);
        // console.log("item >> ", item);
        if (item && item.cid) {
          // console.log("item.cid >> ", item.cid, " :: ", this.curcategory);
          let layout = await this.initRouteByCid(item.cid),
            hero = _.find(layout.children, { type: "slider" });
          this.$set(this, "hero", hero);
          await this.initFilters();
          await this.initItems();
          /*
            1. Make sure the PRODUCT_ATTR Hash is ready...
            if not fetch it.

            2. Fetch the catalog items 
        */
        } else {
          this.category = 404;
        }
        // this.initResizeObserver();
        this.$nextTick(function() {
          this.initResizeElements();
        });
        return true;
      });
    },
    async fetchCatalogContent(_key, api, prop, parser, dataProp) {
      let ln,
        cc,
        vm = this,
        cid = this.cid;

      // active cache?
      let useCache = vm.$useCache[_key];
      // locale keys
      ({ ln, cc } = this.locale);
      return new Promise(resolve => {
        // Desctructing this.locale to variables => ln & cc

        let storageKey = `${_key}_${cid}_${ln}_${cc}`;
        let _data = storage.get(storageKey);
        let dataVersion = -1;
        let json;
        if (_data) {
          // console.log("_data .", _data);
          json = dataProp ? JSON.parse(_data)[dataProp] : JSON.parse(_data);
          // console.log("json .", json);

          dataVersion = _.has(json, "version") ? json.version : -1;
          if (prop) {
            this.$set(this, prop, json);
          }
        }

        fetch(api, {
          headers: {
            cc,
            ln
          }
        })
          .then(function(response) {
            return response.json();
          })
          .then(async function(json) {
            // let version = json.version || -1;
            let data = JSON.parse(json);
            let result = data.Contents || data.ui || data;
            // console.log("dataVersion >> ", _data, dataVersion);
            if (dataVersion !== json.version) {
              if (parser) {
                result = await parser(result);
              }
              if (prop) {
                vm.$set(vm, prop, result);
              }
              useCache && storage.set(storageKey, JSON.stringify(result));
            }
            resolve(result);
          });
      });
    },
    /* 
        Fetch PRODUCT ATTR HASH
    */
    async initCatalogProductAttributes() {
      let content = await this.fetchCatalogContent(
        "productAttr",
        "https://api.mis-implants.com/api/productattributes",
        "productAttributesHash"
      );
      return content;
    },
    async initItems() {
      this.loadingItems = true;
      if (!this.productAttributesHash.length || this.localeChanged) {
        await this.initCatalogProductAttributes();
      }
      //alert("this.cid="+this.cid);
      let catalogProducts = await this.fetchCatalogContent(
        "catalogProducts",
        `https://api.mis-implants.com/api/products/${this.cid}`,
        "items",
        this.parseItems
      );
      // console.log("fetched catalog items (products)...", catalogProducts);
      if (this.$route.params.catId) {
        this.$set(
          this,
          "currentItem",
          _.find(catalogProducts, { cat: this.$route.params.catId })
        );
      }
      this.$nextTick(function() {
        this.loadingItems = false;
        // console.log("2 INITITEMS loading..", this.loadingItems);
        this.checkFilters();
      });
      return catalogProducts;
    },
    async initFilters() {
      let catalogFilters = await this.fetchCatalogContent(
        "catalogFilters",
        `https://api.mis-implants.com/api/catalog/${this.cid}`,
        null,
        this.parseInitialFilters,
        "ui"
      );
      this.filtersReady = true;
      console.log("catalogFilters >> ", catalogFilters);
      /*
            Check route query for active fitlers
            and update the filter hash accordingly
        */
      catalogFilters = this.activateFiltersByQuery(catalogFilters);
      this.updateFiltersHash(catalogFilters);
      this.$nextTick(function() {
        return catalogFilters;
      });
    },
    async parseInitialFilters(filters) {
      _.each(filters, (u, i) => {
        let b = _.find(u.filters, f => f.id === "153");
        if (b) {
          b.label = "B+";
        }
        u.active = false;
        u.visible = i === 0;
        if (u.max && u.max > 0) {
          u.active = true;
          u.value = [u.min, u.max];
        }
      });
      return filters;
    },
    /*
			Use URL query to filter items
			QUERY > TO > FILTER
		*/
    activateFiltersByQuery(_filters) {
      let query = this.$route.query,
        filters = _filters;
      // console.log("activateFiltersByQuery >>>>>>>>>>>> ", query);
      if (query) {
        _.each(query, (v, k) => {
          let values = v.split(",");
          let parent = _.find(filters, { name: k });
          if (parent) {
            if (parent.value) {
              parent.value = values;
              parent.active = true;
            } else {
              _.each(values, value => {
                let item = _.find(
                  parent.filters,
                  f => f.name.toLowerCase() === value.toLowerCase()
                );
                if (item) {
                  item.active = true;
                }
              });
            }
            parent.visible = true;
          }
        });
      }
      return filters;
    },
    async parseItems(items) {
      // console.log("ITEMS > ", items);
      let vm = this,
        filtersHash = this.filtersHash,
        _attributes = this.productAttributesHash;
      // console.log("_attributes >> ", _attributes);
      // console.log("filtersHash >> ", filtersHash);
      return new Promise(resolve => {
        let _items = items.map(function(item) {
          let attr_item = _.filter(
            _attributes,
            attr => attr[2] === item.ProductId
          );

          var obj = {
            _id: item.Id,
            productId: item.ProductId,
            cat: item.CatalogNo,
            title: item.ShortName,
            description: item.Description,
            image: `${vm.$imageFolder}/catalog/products/large/${item.CatalogNo}.png`,
            thumb: `${vm.$imageFolder}/catalog/products/thumbs/${item.CatalogNo}.png`,

            attachments: []
          };

          //_attributes
          //array of att items for each product
          //att[0] = ProAttTypeID 
          //att[1] = ProAttVal
          //att[2] = ProductID

          //look for the emergence profile att, check if it contains concave
          let epAtt = _.filter(_attributes,attr => attr[2] === item.ProductId && attr[0] === 44);
          if(epAtt!=null){
            if(epAtt.length>0){
              let attVal = epAtt[0][1];
              obj.emg_profile_id = attVal;//shouldl be 201 if the profile is 'concave'
            }
          }

          Object.assign(
            obj,
            _.reduce(
              attr_item,
              (_obj, at) => {
                let key,
                  val,
                  val2,
                  _filterItem = _.find(
                    filtersHash,
                    f => parseInt(f.type) === parseInt(at[0])
                  );
                if (_filterItem) {
                  key = _filterItem.name.toLowerCase().replace(" ", "_");
                  if (at[3] && !_.isNull(at[3]) && at[3] > 0) {
                    val = at[3];
                  } else if (at[1] && at[1] > 0) {
                    let _filterVal = _.find(_filterItem.filters, ff => {
                      return parseInt(ff.id) === parseInt(at[1]);
                    });
                    if (_filterVal) {
                      val = _filterVal.label || _filterVal.name;
                      // Hold the name for when english label is needed...
                      val2 = _filterVal.name;
                    }
                  }
                  if (key && val) {
                    if (_obj.hasOwnProperty(key)) {
                      // item already has this prop,
                      // make into array and make multiple
                      if (typeof _obj[key] === "string") {
                        _obj[key] = [_obj[key]];
                        if (key === "platform") {
                          _obj["platform_eng"] = [_obj["platform_eng"]];
                        }
                      }
                      if (_.isNumber(_obj[key].length)) {
                        _obj[key].push(val);
                        if (key === "platform") {
                          _obj["platform_eng"].push(val2);
                        }
                      }
                    } else {
                      _obj[key] = val;
                      if (key === "platform") {
                        _obj["platform_eng"] = val2;
                      }
                    }
                  }
                }
                return _obj;
              },
              {}
            )
          );
          if (item.MediaVideo) {
            obj.attachments.push({
              label: vm.localize("video"),
              link: item.MediaVideo,
              type: "video"
            });
          }
          if (item.PrintCatalog) {
            obj.attachments.push({
              label: "PDF",
              link: `http://www.mis-implants.com/upload/${item.PrintCatalog}`,
              type: "file-pdf"
            });
          }
          // console.log("_obj> ", obj);

          return obj;
        });
        let finalitems = _.uniqBy(_items, "productId");
        resolve(finalitems);
      });
    },
    filtersChangedHandler(activefilters) {
      // console.log("filtersChangedHandler >> ", activefilters);
      this.activeFilters = activefilters;
      if (this.items.length) {
        this.checkFilters();
      }
    },
    async checkFilters() {
      // console.log("checkFilters >> ");
      this.gridReady = false;
      this.$set(this, "filteredItems", []);
      this.$nextTick(async function() {
        this.$set(this, "filteredItems", await this.filterItems());
        // console.log("grid READY ");
        if (!this.loadingItems) {
          this.gridReady = true;
        }
      });
    },

    async filterItems() {
      console.log("1 FILTER ITESM >> ", this.activeFilters);
      if (!this.activeFilters.length) {
        return this.items;
      }
      let __af,
        group = _.groupBy(this.activeFilters, "type"), // keyed filters
        items = this.items,
        __fi = []; // FILTERED ITEMS

      __af = _.flatMap(group, k => {
        var obj = {};
        _.forEach(k, item => {
          for (var i in item) {
            // console.log(item[i]);
            if (obj[i] && obj[i] !== item[i]) {
              if (typeof obj[i] === "string") {
                obj[i] = obj[i].split(",");
              }
              obj[i].push(item[i]);
            } else {
              obj[i] = item[i];
            }
          }
        });
        return obj;
      });
      // console.log("__af >> ", __af);
      __fi = _.filter(items, item => {
        let pass = true;
        for (var i = 0; i < __af.length; i++) {
          if (!pass) {
            break;
          }
          let f = __af[i],
            filter_prop = _.snakeCase(f.key || f.label || f.name), // FOO BAR > foo_bar
            item_value = item[filter_prop],
            filter_value;
          pass = !!item_value;
          if (pass && f.value) {
            // NUMERIC
            let integers = _.map(f.value, Number);
            pass =
              item_value &&
              item_value >= integers[0] &&
              item_value <= integers[1];
          } else if (pass) {
            filter_value = f.label || f.name;
            if (
              typeof filter_value !== "string" &&
              typeof item_value !== "string"
            ) {
              pass = _.intersection(filter_value, item_value).length;
            } else {
              // console.log("FILTERIN...", item_value, " :: ", filter_value);
              pass =
                (_.isArray(item_value)
                  ? item_value.indexOf(filter_value) > -1
                  : item_value === filter_value) ||
                (_.isArray(filter_value)
                  ? filter_value.indexOf(item_value) > -1
                  : filter_value === item_value);
              // console.log("PASS: ", pass);
            }
          }
        }
        return pass;
      });
      return __fi;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    /*
      Will set off everytime an element has
      resized and will change a random trigger
      that Components can listen to if needed.
    */
    triggerResize: _.debounce(function() {
      this.resizeTrig = new Date().getTime();
    }, 300),
    toggleMobileCats() {
      this.openMobileCats = !this.openMobileCats;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    }
  }
};
</script>
<style lang="stylus">
.mobile-top-bar
  min-height 40px
.infinite
  opacity 1
  &.hidden
    opacity 0
    transition opacity 0.3s ease-out
  span
    padding-top 90px
    font-size responsive 12px 14px
.subnote
  text-align left
  /.el-size--large &
  /.el-size--medium &
    pad('2xl')
    margin-left 240px
.page
  position relative
  // background linear-gradient(to bottom, gray_0 80%, #fff)
  z-index 9
.catalog
  background #fff
  min-height 70vh
  // &.filters-open
  //   max-height 120vh
  //   overflow hidden
  &--inner
    width 100%
    // padding-top 100px
    position relative
    _flex(row, nowrap, flex-start, space-between)
    text-align left
    /.el-size--small &
      padding-top 10px
  &.filter-panel__mobile
    top -4vh
  &--grid
    position relative
    &.loading
      min-height 45vh
    &.grid-no-items
      display flex
      align-items center
      justify-content center
      min-height 60vh
      flex-direction column 
      h4
        padding 30px
      i
        display block
        font-size responsive 30px 80px
        opacity 0.55
        margin 0 auto 20px
        text-align center
.catalog-categories
  position sticky
  top 179px //146px Dubi added 33px for the top strip diff
  z-index 21
  background gray_1
  box-shadow 0px 2px 12px rgba(gray_7, 0.4)
  height 10vh
  _flex(row, nowrap, stretch, space-between)
  min-height 60px
  a
    flex 1
    position relative
    color gray_8
    transition background-color 0.3s ease-out
    border-right 1px solid gray_4
    _flex(row, nowrap, center,center)
    max-width 20%
    .inline-icon
      flex 0 0 15%
      max-width 15%
      line-height 1
    svg
      stroke gray_6
      transition stroke 0.3s ease-out
      +below(1400px)
        max-height 38px
    span
      flex none
      max-width 48%
      text-align left
      line-height 1.1
      // overflow hidden
      // text-overflow ellipsis
      // white-space nowrap
    &:first-child
      border-left 1px solid gray_4
    &.router-link-active
    &:hover
      background blue_primary
      svg
        stroke #fff
      span
        color #fff
  &__mobile
    position relative
    top initial
    transform none
    // height 30px
    _flex(row, wrap, flex-end, flex-end)
  &__list
    position absolute
    width 100%
    min-width 220px
    _flex(column, nowrap, flex-start, flex-start)
    border 1px solid gray_2
    background #fff
    top 100%
    z-index 9
    a
      _flex(row, nowrap, center, flex-start)
      width 100%
      text-align left
      &:nth-child(odd)
        background gray_2
      .inline-icon
        flex 0 0 10%
        line-height 1
        svg
          stroke gray_6
      span
        flex none
        width 100%
        font-size 14px
      &.router-link-active
      &:hover
        background #fff
        svg
          stroke blue_primary
    a,
    a:visited
      color gray_8
      // &:not(:last-child)
      //   marg('xl', bottom)
  &__cur
    border-bottom 1px solid gray_6
    i
      color gray_6
      font-size 90%
</style>
